module.exports = ["A1","A2","A3","A4","A5","A6","A7"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/workplaces.json
// module id = 283
// module chunks = 1